import { Component, Emit, Prop, Ref } from 'vue-property-decorator'
import { LaboratoryStatisticalAnalysisSidebarDateInput } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.model'
import { BModal } from 'bootstrap-vue'
import { StatisticalAnalysisDossiers, StatisticalAnalysisDossiersChartResponsesTypes, StatisticalAnalysisDossiersDatasourceResponsesTypes, StatisticalAnalysisDossiersExternalInfo, StatisticalAnalysisEnumsAndKeys, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisViewDetailTableFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.model'
import { get, has, isArray } from 'lodash'
import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { StatisticalInfoPaginatorTrackingItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.model'
import Vue from 'vue'
import { initialStatisticalAnalysisExternalViewDetailChartState, StatisticalAnalysisExternalViewDetailChartState } from '@/modules/statistical-analysis-module/components/statistical-analysis-external-views/statistical-analysis-external-views-detail-chart/statistical-analysis-external-views-detail-chart.model'
import Highchart from '@/components/common/highchart/highchart.vue'
import { statisticalAnalysisHandlerFactory } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handler.factory'
import { Formatter } from '@/filters/formatter'

@Component({
    components: {
        Highchart
    }
})
export default class StatisticAnalysisExternalViewDetailChart extends Vue {
    @Ref() readonly statisticalAnalysisExternalViewsDetailTableModal!: BModal
    @Prop() readonly row!: StatisticalAnalysisDossiersDatasourceResponsesTypes
    @Prop() readonly filters!: StatisticalAnalysisViewDetailTableFilters
    @Prop() readonly viewDetailParams!: StatisticalAnalysisViewDetailParams
    state: StatisticalAnalysisExternalViewDetailChartState
    @Emit()
    hideModal(): boolean {
        return false
    }

    constructor() {
        super()
        this.state = initialStatisticalAnalysisExternalViewDetailChartState()
    }

    get getDossier(): string {
        switch (this.viewDetailParams.dossier) {
        case StatisticalAnalysisDossiers.GENERAL:
            return StatisticalAnalysisEnumsAndKeys.GENERAL_STATISTICS.getText()
        case StatisticalAnalysisDossiers.ACTIVITY:
            return StatisticalAnalysisEnumsAndKeys.ACTIVITY_STATISTICS.getText()
        case StatisticalAnalysisDossiers.INCIDENTS:
            return StatisticalAnalysisEnumsAndKeys.INCIDENTS_STATISTICS.getText()
        case StatisticalAnalysisDossiers.DELAYS_AND_RESPONSE_TIMES:
            return StatisticalAnalysisEnumsAndKeys.DELAYS_AND_RESPONSE_STATISTICS.getText()
        case StatisticalAnalysisDossiers.SAMPLE_TAGS:
            return StatisticalAnalysisEnumsAndKeys.SAMPLE_TAGS_STATISTICS.getText()
        default:
            return ''
        }
    }

    get laboratoriesSelected(): LaboratoryStatisticalAnalysisSidebarDateInput[] {
        return this.filters.externalFiltering.sidebarFilters?.laboratories as LaboratoryStatisticalAnalysisSidebarDateInput[]
    }

    get gridtitle(): string {
        const sidebar: StatisticalAnalysisDossiersExternalInfo = this.filters.externalFiltering.sidebarFilters as StatisticalAnalysisDossiersExternalInfo
        if (sidebar.trackingGeneralSelected) {
            if (has(sidebar, 'trackingDetailSelected')) {
                const trackingDetailSelected: StatisticalInfoPaginatorTrackingItems = get(sidebar, 'trackingDetailSelected')
                return `${this.$tc(sidebar?.trackingGeneralSelected?.label)} - ${this.$tc('statisticalAnalysis.dossiers.generalStatistics.detailFor')} ${this.$tc(trackingDetailSelected?.label)}`
            } else {
                return `${this.$tc(sidebar?.trackingGeneralSelected?.label)}`
            }
        } else {
            return Formatter.capitalize(`${this.$tc('statisticalAnalysis.dossiers.generalStatistics.detailFor')} ${this.$tc(this.getDossier)}`)
        }
    }

    get typeCase(): string {
        if (isArray(this.filters.externalFiltering.sidebarFilters?.typeSearch)) {
            const texts = this.filters.externalFiltering.sidebarFilters?.typeSearch.map((item: StatisticalAnalysisSidebarItemCombo) => this.$tc(item.text, 2))
            return (texts as string[])?.join(', ')
        } else {
            return this.$tc(this.filters.externalFiltering.sidebarFilters?.typeSearch?.text as string, 2)
        }
    }

    get startDate(): Date {
        return this.filters.externalFiltering.sidebarFilters?.startDate as Date
    }

    get endDate(): Date {
        return this.filters.externalFiltering.sidebarFilters?.endDate as Date
    }

    async mounted(): Promise<void> {
        await this._getChartData(statisticalAnalysisHandlerFactory.getDetailChart(this.viewDetailParams.dossier, this.filters, this.state.extendedChartOptions, this.row) as StatisticalAnalysisDossiersChartResponsesTypes)
        this.statisticalAnalysisExternalViewsDetailTableModal.show()
    }

    onHide(): void {
        this.hideModal()
    }

    onShown(): void {
        this.state.modalShown = true
    }

    private async _getChartData(instanceChart: StatisticalAnalysisDossiersChartResponsesTypes): Promise<void> {
        const [error, response] = await this.$_toCall(instanceChart.getChart(), true)
        this.state.extendedChartOptions = {
            ...this.state.extendedChartOptions,
            xAxis: {
                ...this.state.extendedChartOptions.xAxis,
                categories: error ? [] : response.categories
            },
            series: error ? [] : response.series
        }
    }
}
